import { getTimingFactor, roundNumber, toKeyframeValue, mapRange } from '../../utils';
const POWER_TO_RUBBER_OFFSET_MAP = {
  soft: 0,
  medium: 0.05,
  hard: 0.1
};
const SCALE_KEYFRAMES = [{
  keyframe: 45,
  scaleX: 1.03,
  scaleY: 0.93
}, {
  keyframe: 56,
  scaleX: 0.9,
  scaleY: 1.03
}, {
  keyframe: 66,
  scaleX: 1.02,
  scaleY: 0.96
}, {
  keyframe: 78,
  scaleX: 0.98,
  scaleY: 1.02
}, {
  keyframe: 89,
  scaleX: 1.005,
  scaleY: 0.9995
}, {
  keyframe: 100,
  scaleX: 1,
  scaleY: 1
}];
export function web(options, _dom) {
  return style(options, true);
}
export function style(options, asWeb) {
  if (asWeb === void 0) {
    asWeb = false;
  }
  const {
    power,
    intensity = 0.5
  } = options.namedEffect;
  const duration = options.duration || 1;
  const delay = options.delay || 0;
  const timingFactor = getTimingFactor(duration, delay);
  const [name] = getNames(options);
  const responsiveRubberOffset = mapRange(0, 1, POWER_TO_RUBBER_OFFSET_MAP.soft, POWER_TO_RUBBER_OFFSET_MAP.hard, intensity);
  const rubberOffset = typeof power !== 'undefined' ? POWER_TO_RUBBER_OFFSET_MAP[power] : responsiveRubberOffset;

  // Create CSS custom properties for the rubber configuration
  const custom = {};
  const keyframes = SCALE_KEYFRAMES.map((_ref, index) => {
    let {
      keyframe,
      scaleX,
      scaleY
    } = _ref;
    const isLastKeyframe = index === SCALE_KEYFRAMES.length - 1;
    const isEvenKeyframe = index % 2 === 0;
    const offset = rubberOffset * (isLastKeyframe ? 0 : isEvenKeyframe ? 1 : -0.5);
    const adjustedScaleX = roundNumber(scaleX + offset, 4);
    const adjustedScaleY = roundNumber(scaleY - offset, 4);

    // Create custom property keys for this keyframe
    const scaleXKey = `--motion-scale-x-${keyframe}`;
    const scaleYKey = `--motion-scale-y-${keyframe}`;

    // Add the scale values to custom properties
    custom[scaleXKey] = adjustedScaleX;
    custom[scaleYKey] = adjustedScaleY;
    return {
      offset: keyframe / 100 * timingFactor,
      transform: `rotateZ(var(--comp-rotate-z, 0deg)) scale(${toKeyframeValue(custom, scaleXKey, asWeb)}, ${toKeyframeValue(custom, scaleYKey, asWeb)})`
    };
  });
  return [{
    ...options,
    name,
    easing: 'linear',
    delay: 0,
    duration: duration + delay,
    custom,
    keyframes
  }];
}
export function getNames(options) {
  const timingFactor = getTimingFactor(options.duration, options.delay, true);
  return [`motion-rubber-${timingFactor}`];
}
//# sourceMappingURL=Rubber.js.map